import { render, staticRenderFns } from "./StationInstructions.vue?vue&type=template&id=1b5f3826&scoped=true"
import script from "./StationInstructions.vue?vue&type=script&lang=js"
export * from "./StationInstructions.vue?vue&type=script&lang=js"
import style0 from "./StationInstructions.vue?vue&type=style&index=0&id=1b5f3826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5f3826",
  null
  
)

export default component.exports